import styles from './index.module.css'
import * as React from 'react'
import Flex from 'components/ui/flex'
const isMac = navigator.platform.includes('Mac')
type Props = {
  keys: string[]
  appearance?: 'string' | 'buttons'
}

/**
 * A component that displays keyboard shortcuts with OS-specific key mappings
 * @param keys - Array of key names to display (e.g., ['Ctrl', 'C'])
 * @param appearance - Display style: 'string' for joined text or 'buttons' for individual key buttons (defaults to 'string')
 * @returns A keyboard shortcut display with OS-appropriate key symbols
 */
const Hotkey = ({ keys, appearance = 'string' }: Props): React.ReactNode => {
  const keysByOS = keys.map(key => {
    const upper = key.toUpperCase()

    if (upper === 'CTRL' || upper === 'CMD') {
      if (isMac) {
        return '⌘'
      } else {
        return 'Ctrl'
      }
    }

    return key
  })

  if (appearance === 'buttons') {
    const buttons = keysByOS.map((key, index) => (
      <React.Fragment key={index}>
        <span className={styles.button}>{key}</span>
        {index !== keysByOS.length - 1 && (
          <span className={styles.plus}>+</span>
        )}
      </React.Fragment>
    ))
    return <Flex spacing="none">{buttons}</Flex>
  }

  return <span>{keysByOS.join('+')}</span>
}

export default Hotkey
